import { Button } from "react-bootstrap";
import { DDD } from "../../lib/ddd/ddd";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);
const ConnectionKeyRequest = () => {

    const sendRequest = () =>{
        const ddd = DDD.WithConnectionKey(apiRequestAddress, "0b85ec08-f2d7-4318-8ecf-02c01ea848c6", true);
        console.log(ddd.getRpcClient())
        ddd.Rpc_ExecuteExtension("EUeInvoices.GetCurrentTData").then(res => {
          console.log(res);
        }).catch((er)=>{
          console.log(er); 
        });
    }

    const sendNormal = () => {
        ddd.Rpc_ExecuteExtension("EUeInvoices.GetCurrentTData").then(res => {
            console.log(res);
        }).catch((er)=>{
            console.log(er); 
        });
    }

    return (
        <>
        <Button onClick={sendRequest}>Click with connection key</Button>
        <Button onClick={sendNormal}>Click Normal</Button>
        </>
    )
}

export default ConnectionKeyRequest;